// 공통 번역 - 네비게이션, 푸터, 페이지네이션
export default {
  nav: {
    home: 'Home',
    about: 'About',
    news: 'News',
    gallery: 'Gallery',
    calendar: 'Calendar'
  },
  footer: {
    churchName: 'Seongdong Jungang Church',
    description: 'A welcoming community where faith comes alive. Join us as we grow together in love, worship, and service to God and our neighbors.',
    contactUs: 'Contact Us',
    address: '468 Ttukseom-ro, Gwangjin-gu, Seoul',
    phone: '02-463-1009 / 02-499-1004',
    fax: '02-463-1113',
    email: '01190715326@naver.com',
    serviceTimes: 'Service Times',
    sundayMorning: 'Sunday Morning',
    sundayMorningTime: '11:00 AM',
    sundayPraise: 'Sunday Praise',
    sundayPraiseTime: '3:00 PM',
    wednesday: 'Wednesday',
    wednesdayTime: '11:00 AM',
    fridayPrayer: 'Friday Prayer',
    fridayPrayerTime: '9:00 PM',
    copyright: '© 2025 Seongdong Jungang Church. All rights reserved.',
    poweredBy: 'Powered by YoungSeok Choi'
  },
  pagination: {
    prev: 'Prev',
    next: 'Next',
    pageOf: 'Page {{current}} of {{total}}'
  },
  language: {
    ko: '한국어',
    en: 'English'
  },
  loading: 'Loading...'
};
